import { validatePresence } from 'ember-changeset-validations/validators';

export default {
  field: validatePresence({ presence: true, message: 'This is a required field' }),
  value: validatePresence({ presence: true, message: 'This is a required field' }),
};
